import BaseClient from '@/app/model/api/response/baseApiClient'

class CamImageApi extends BaseClient {
  public getCamImageData (data: any) {
    const path = '/v1/cam-images'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    params.append('record_date', data.record_date)

    if (data.has_camera) {
      params.append('has_camera', '1')
    } else {
      params.append('has_camera', '0')
    }

    if (data.has_planting) {
      params.append('has_planting', '1')
    } else {
      params.append('has_planting', '0')
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new CamImageApi()
